import { populateCategories, populateLeveranciers } from "./actions";
import { fetchCategories, fetchLeveranciers } from "./controls";

export function* getCategories() {
    const categories = yield fetchCategories();
    return populateCategories(categories);
}

export function* getLeveranciers() {
    const leveranciers = yield fetchLeveranciers();
    return populateLeveranciers(leveranciers);
}